import { useConfigs } from 'api/configurations';
import { useIdPConfigContext } from 'contexts/IdPConfigContext';
import { useEffect, useMemo, useState } from 'react';
import {
	queryToFieldsConfigs,
	queryToScimIdPId,
	queryToXaaIdPId
} from 'utils/loadConfigs';

export default (enabled: boolean) => {
	const [done, setDone] = useState(false);

	const { data: configsData } = useConfigs();

	const {
		idpID: currentIdPId,
		method: currentMethod,
		scimIdpID: currentScimIdpID,
		scimMethod: currentScimMethod,
		xaaIdpID: currentXaaIdpID,
		xaaMethod: currentXaaMethod,
		setIdPID,
		setMethod,
		setScimIdPID,
		setScimMethod,
		setXaaIdPID,
		setXaaMethod,
		setIsSubTenant
	} = useIdPConfigContext();

	useEffect(() => {
		if (done || !enabled || !configsData) {
			return;
		}

		// queryToFieldsConfigs resolves ONLY SAML/OIDC - XAA has its own resolver so an
		// XAA-configured tenant never seeds the SSO idp/method (keeping the SSO card clean).
		const [idpId, method] = queryToFieldsConfigs(configsData);
		const [scimIdPId, scimMethod] = queryToScimIdPId(configsData);
		const [xaaIdPId, xaaMethod] = queryToXaaIdPId(configsData);

		setDone(true);
		setIsSubTenant(
			!!(configsData.oauth.lockedTenantId || configsData.saml.lockedTenantId)
		);
		if (!(currentIdPId || currentMethod) && idpId && method) {
			setMethod(method);
			setIdPID(idpId);
		}
		if (!(currentScimIdpID || currentScimMethod) && scimIdPId && scimMethod) {
			setScimIdPID(scimIdPId);
			setScimMethod(scimMethod);
		}
		if (!(currentXaaIdpID || currentXaaMethod) && xaaIdPId && xaaMethod) {
			setXaaIdPID(xaaIdPId);
			setXaaMethod(xaaMethod);
		}
	}, [
		configsData,
		currentIdPId,
		currentMethod,
		currentScimIdpID,
		currentScimMethod,
		currentXaaIdpID,
		currentXaaMethod,
		done,
		enabled,
		setIdPID,
		setMethod,
		setScimIdPID,
		setScimMethod,
		setXaaIdPID,
		setXaaMethod,
		setIsSubTenant
	]);

	return useMemo(() => ({ done }), [done]);
};
